import { makeStyles } from "@material-ui/core/styles";

const useBannerStyles = makeStyles((theme) => ({
  mainBanner: {
    position: "relative",
    background: 'transparent',
    color: theme.palette.common.white,
    paddingTop: theme.spacing(10),
    borderRadius: 0,
    boxShadow: 'none',
    marginBottom: 0,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 20% 80%, rgba(0, 212, 170, 0.18) 0%, transparent 45%), radial-gradient(circle at 80% 20%, rgba(102, 126, 234, 0.18) 0%, transparent 45%)',
      pointerEvents: 'none',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '-10%',
      left: 0,
      right: 0,
      height: '2px',
      background: 'linear-gradient(90deg, transparent, #00d4aa, transparent)',
      animation: 'scanLine 3s linear infinite',
      pointerEvents: 'none',
    },
  },
  textContainer: {
    position: "relative",
    zIndex: 10,
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(12),
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3),
    },
  },
  title: {
    fontFamily: '"vester-poster", "Montserrat", "Inter", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.04em',
    lineHeight: 0.96,
    background: 'linear-gradient(135deg, #ffffff 0%, #cdfaf1 45%, #6fe9d6 75%, #19b7e6 100%)',
    backgroundSize: '200% 200%',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    animation: 'gradientShift 6s ease infinite',
    textShadow: 'none',
    [theme.breakpoints.down("sm")]: {
      fontSize: '2.4rem',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.up("md")]: {
      fontSize: '4.6rem',
    },
  },
  subTitle: {
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    fontWeight: 500,
    letterSpacing: '0.01em',
    color: '#d8e2ee',
    textShadow: '0 2px 20px rgba(0, 0, 0, 0.3)',
    [theme.breakpoints.down("sm")]: {
      fontSize: '1.3rem',
      paddingBottom: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.up("md")]: {
      fontSize: '2rem',
    },
  },
  reason: {
    color: "#86f8e1",
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    fontWeight: 700,
    textShadow: '0 0 40px rgba(0, 212, 170, 0.55), 0 0 80px rgba(0, 212, 170, 0.3)',
    animation: 'aiGlow 2.4s ease-in-out infinite',
    display: 'inline-block',
    [theme.breakpoints.down("sm")]: {
      fontSize: '1.25rem',
      paddingBottom: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.up("md")]: {
      fontSize: '1.85rem',
    },
  },
}));
export default useBannerStyles;
